/** Member keys are unique across a cube's three member maps, so lookup order only breaks ties. */
export const findMemberMeta = (cube, member) => cube.dimensions[member] ?? cube.timeDimensions[member] ?? cube.measures[member];
/** Creates a {@link ReportMemberLink} for the given id member and path. */
export const reportMemberLink = (idMember, path, requiresSystemAdmin, requiresMeetingBodyAdmin) => ({
    idMember,
    path,
    requiresSystemAdmin: requiresSystemAdmin ?? /^\/admin\//.test(path),
    requiresMeetingBodyAdmin: requiresMeetingBodyAdmin ?? /^\/admin\/meeting-bodies\//.test(path),
});
